module.exports = __webpack_public_path__ + "static/img/logo-part-2.9fab5338.png";